/*
  RebelsMarket — shared full-screen player for the how-to-measure videos.

  Triggers are rendered by snippets/rm-measure-video.liquid as
    <button data-rm-measure-video data-src data-poster data-label data-slug data-surface>
  One delegated click listener on document handles every trigger, including ones inside
  drawers rendered after this script ran. The player DOM is created on the first tap;
  nothing video-related loads before that.

  Closing (button, Escape, backdrop tap, or the video ending) pauses the video, unsets
  its src so the download stops, and restores whatever <body> inline styles were there
  before opening, so a size-chart drawer underneath keeps its own scroll lock.
*/
(function () {
  'use strict';
  if (window.__rmMeasureVideo) return;
  window.__rmMeasureVideo = true;

  var overlay = null;
  var video = null;
  var closeBtn = null;
  var lastTrigger = null;
  var saved = null;

  var BODY_PROPS = ['position', 'top', 'left', 'right', 'width', 'overflow'];

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'rm-mvideo-player';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.hidden = true;

    closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'rm-mvideo-player__close';
    closeBtn.setAttribute('aria-label', 'Close video');
    closeBtn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';

    video = document.createElement('video');
    video.className = 'rm-mvideo-player__video';
    video.setAttribute('controls', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('preload', 'auto');
    video.setAttribute('tabindex', '0');
    video.playsInline = true;

    overlay.appendChild(video);
    overlay.appendChild(closeBtn);
    document.body.appendChild(overlay);

    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      // The theme's drawer closes on any document click outside itself; keep clicks on
      // the player from reaching document so the size-chart drawer underneath stays open.
      e.stopPropagation();
      if (e.target === overlay) close();
    });
    overlay.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      // Keep keyboard focus inside the player (video controls <-> close button).
      var first = video;
      var last = closeBtn;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    video.addEventListener('ended', close);
  }

  function lockScroll() {
    var b = document.body;
    var alreadyFixed = b.style.position === 'fixed';
    saved = { styles: {}, scrollY: window.pageYOffset || document.documentElement.scrollTop || 0, alreadyFixed: alreadyFixed };
    BODY_PROPS.forEach(function (p) { saved.styles[p] = b.style[p]; });
    if (!alreadyFixed) {
      b.style.position = 'fixed';
      b.style.top = -saved.scrollY + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
    }
    b.style.overflow = 'hidden';
  }

  function unlockScroll() {
    if (!saved) return;
    var b = document.body;
    BODY_PROPS.forEach(function (p) { b.style[p] = saved.styles[p]; });
    if (!saved.alreadyFixed) window.scrollTo(0, saved.scrollY);
    saved = null;
  }

  function isOpen() {
    return !!overlay && !overlay.hidden;
  }

  function open(trigger) {
    var src = trigger.getAttribute('data-src');
    if (!src) return;
    if (!overlay) build();
    if (isOpen()) close();

    lastTrigger = trigger;
    var label = trigger.getAttribute('data-label') || 'Video';
    overlay.setAttribute('aria-label', label);
    video.setAttribute('aria-label', label);
    video.poster = trigger.getAttribute('data-poster') || '';
    video.src = src;
    video.setAttribute('autoplay', '');

    overlay.hidden = false;
    lockScroll();
    closeBtn.focus({ preventScroll: true });

    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () { /* controls stay visible; user can tap play */ });

    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('rm_measure_video_play', {
          video: trigger.getAttribute('data-slug') || '',
          surface: trigger.getAttribute('data-surface') || ''
        });
      }
    } catch (err) { /* analytics must never block playback */ }
  }

  function close() {
    if (!isOpen()) return;
    video.pause();
    video.removeAttribute('autoplay');
    video.removeAttribute('src');
    video.load();
    overlay.hidden = true;
    unlockScroll();
    if (lastTrigger && document.contains(lastTrigger)) {
      try { lastTrigger.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
    }
    lastTrigger = null;
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-rm-measure-video]') : null;
    if (!t) return;
    e.preventDefault();
    open(t);
  });

  // Capture phase so Escape closes the video first and doesn't also close the drawer
  // below. The drawer listens for Escape on keyup, and focus is back inside it by then,
  // so swallow that one keyup too.
  var swallowEscapeKeyup = false;
  function isEscape(e) { return e.key === 'Escape' || e.key === 'Esc'; }
  document.addEventListener('keydown', function (e) {
    if (isEscape(e) && isOpen()) {
      e.preventDefault();
      e.stopPropagation();
      swallowEscapeKeyup = true;
      close();
    }
  }, true);
  document.addEventListener('keyup', function (e) {
    if (isEscape(e) && swallowEscapeKeyup) {
      swallowEscapeKeyup = false;
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();
